import { useEffect } from "react";

const SITE = "Summit Transformation Group";

export function useSEO(title, description) {
  useEffect(() => {
    document.title = title ? `${title} | ${SITE}` : SITE;
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      document.head.appendChild(meta);
    }
    meta.content = description || "";
  }, [title, description]);
}
